import React from 'react';
import Navbar from "./components/Navbar";
import {userLogin} from '../services/UserService';
import NotificationPanel from "./components/NotificationPanel";

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
           username:  "",
           password: "",
           notifyMessage: ""
        };
        this.handleUpdate = this.handleUpdate.bind(this);
    }

    handleUpdate(responseToken, mail, admin){
        this.props.handleLogin(responseToken, mail, admin)
    }

    handleInputChange = (e) => {
        if (e.target.name === "username") {
            this.setState({ username: e.target.value});
        }
        else if (e.target.name === "password") {
            this.setState({ password: e.target.value});
        }
    };

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.state.username === "" || this.state.password === "") {
            this.setState({notifyMessage: "Empty username/password field"});
        } else  {
            userLogin(this.state.username, this.state.password)
                .then(promise =>
                   {
                        if (promise.error) {
                            window.alert("Server is not responding.");
                            return;
                        } else if (!promise.ok) {
                            window.alert("Invalid user credentials.");
                            return;
                        }

                        promise.json()
                        .then(response => {
                            if (response.jwtToken != null) {
                                window.sessionStorage.setItem("jwtToken", response.jwtToken);
                                window.sessionStorage.setItem("userMail", this.state.username);
                                window.sessionStorage.setItem("isAdmin", response.isAdmin);
                                this.handleUpdate(response.jwtToken, this.state.username, response.isAdmin);
                            } else {
                                this.setState({notifyMessage: "Invalid username/password"});
                            }
                        });
                   }
                );
        }
    };

    render() {
    return (
    <>
        <Navbar loggedIn={false} />
        <div>
            <div className="row">
                <div id="formBlock" className="text-left" >
                  <form style={{marginLeft: "auto",
                                 marginRight: "auto",
                                 width: "350px"}}>
                    <h1>Login</h1>
                    <div className="form-group">
                      <label>Username</label>
                      <input className="form-control" type="text" name="username" onChange={(e) => this.handleInputChange(e)} />
                    </div>

                    <div className="form-group">
                      <label>Password</label>
                      <input className="form-control" type="password" name="password" onChange={(e) => this.handleInputChange(e)}/>
                    </div>
                    <button type="submit" className="btn btn-primary" onClick={this.handleSubmit} >
                      Submit
                    </button>
                    <NotificationPanel type="error" message={this.state.notifyMessage}/>
                  </form>
              </div>
            </div>
        </div>
    </>
    );
    }
}

export default Login;
